<div class="modal-header relative">
    <h4 class="modal-title-top20">Product Details</h4>
    <div class="cls-btn">
        <img [src]="'../../assets/icons/'+baseSiteId+'/close.svg'" (click)="close()" alt="">
    </div>
</div>
<div class="modal-body miniCart-popover">
    <div class="row row-20 product-details pb-3" id="leftCont-rightNav">
        <section class="row row-20">
            <section class="container-pdp">
                <aside aria-label="Product Details" id="prodImg"
                    class="col-xs-12 col-sm-4 col-md-4 right-navigation float-right">
                    <a
                        *ngIf="productDetails?.product?.images != undefined || productDetails?.product?.images?.length > 0">

                        <img class="image-product" src="{{images?.PRIMARY?.url}}" alt="" (click)="openImage(content)">

                    </a>
                    <a
                        *ngIf="productDetails?.product?.images === undefined || productDetails?.product?.images?.length === 0">
                        <img class="image-set-in-card product-img"
                            [src]="'../../assets/icons/'+baseSiteId+'/sanofi_missing_product.jpg'" alt=""
                            (click)="openImage(content)">
                    </a>
                    <span class="fullscreen-image selected align-bottom" data-toggle="modal"
                        data-target="#pdp-image-zoom">
                        <a (click)="openImage(content)" title="fullscreen link"><img class="expandable"
                                [src]="'../../../assets/icons/'+baseSiteId+'/fullscreen.svg'" alt="" /></a>
                    </span>
                    <a>
                        <div *ngFor="let carousel of gallery">
                            <div class="xzoom-thumbs leftFloat">
                                <a class="item">
                                    <cx-media class="cx-product-image carousel-zoom" [container]="carousel?.product"
                                        format="product" [alt]="img">
                                    </cx-media>
                                </a>
                            </div>
                        </div>
                    </a>
                    <br /><br />
                    <ng-template #content let-modal>
                        <ngb-carousel *ngIf="
              productDetails?.product?.images != undefined ||
              productDetails?.product?.images?.length > 0
                " ngClass="productDetails?.product?.images?.GALLERY.length > 0 ? 'carousel-nopagination' : 'carousel-pagination' ">
                            <ng-template ngbSlide *ngFor="let carousel of gallery">
                                <div class="text-right mt-2 mr-2">
                                    <div class="closeBtn">
                                        <a (click)="modal.dismiss()"><img
                                                [src]="'../../../assets/icons/'+baseSiteId+'/close.svg'"
                                                width="20px" /></a>
                                    </div>
                                </div>

                                <div class="picsum-img-wrapper">
                                    <cx-media class="cx-product-image carousel-pdp" [container]="carousel?.product"
                                        format="product" [alt]="img">
                                    </cx-media>
                                    <div class="xzoom-thumbs">
                                        <a class="item">
                                            <cx-media class="cx-product-image carousel-zoom"
                                                [container]="carousel?.product" format="product" [alt]="img">
                                            </cx-media>
                                        </a>
                                    </div>
                                </div>
                            </ng-template>
                        </ngb-carousel>
                    </ng-template>
                </aside>
                <section class="col-xs-12 col-sm-8 col-md-8 left-section pb-2 float-left">
                    <h3 class="pdp-title" [innerHTML]="productDetails?.product?.baseProductName"></h3>
                    <p class="desc-class" [innerHTML]="productDetails?.product?.baseProductDescription"></p>
                    <p class="desc-class" [innerHTML]="productDetails?.product?.storageDescription"></p>
                    <p class="desc-class" [innerHTML]="description"></p>
                    <br>
                    <section class="batch-info">
                        <p class="desc-title" *ngIf="productDetails?.product?.batchInfo?.batchNumber">
                            {{'plp.batchNumber'|cxTranslate}}
                            <span class="desc-details">{{productDetails?.product?.batchInfo?.batchNumber}}</span>
                        </p>
                        <p class="desc-title" *ngIf="productDetails?.product?.batchInfo?.batchNumber">
                            {{'plp.expiryDate'|cxTranslate}} :
                            <span class="desc-details">{{productDetails?.product?.batchInfo?.expiryDate}}</span>
                        </p>
                        <p *ngIf="productDetails?.product?.batchInfo?.batchNumber">{{'plp.batchInfo'|cxTranslate}}</p>
                        <p class="ndcCode" *ngIf="productDetails?.product?.ndcCode">
                            {{productDetails?.product?.ndcCode}}</p>
                        <p class="desc-title"><span class="desc-details">{{productDetails?.product?.code}}</span><span
                                class="ml-1 mr-1">|</span>
                            <span>{{productDetails?.product?.manufacturer}}</span>
                        </p>
                        <hr class="line">
                        <section class="sap-allocation-area"
                            *ngIf="!productDetails?.product?.discontinued && productDetails?.product?.available && !productDetails?.product?.flu">
                            <section *ngIf="productDetails?.product?.sapAllocation === true">
                                <b class="prod-allocation">{{'plp.productAllocation'|cxTranslate}}</b>
                                <p class="allocation-p">{{'plp.allocationDetails' | cxTranslate}}
                            </section>
                        </section>
                        <section class="third-col" *ngIf="!productDetails?.product?.unavailable &&
                        productDetails?.product?.orderable &&
                        productDetails?.product?.available &&
                        !productDetails?.product?.discontinued">

                            <section class="row unit-calc" *ngIf="unitSection==='NoUnits'">
                                <section class="col-md-4 col-xs-6 bottom-spacing price-area"
                                    *ngIf=" !productDetails?.product?.flu">
                                    <b>Unit Price</b>
                                    <section class="number">
                                        <span
                                            *ngIf="productDetails?.totalPrice == undefined || productDetails?.totalPrice?.value === undefined">-</span>
                                        <span
                                            *ngIf="productDetails?.totalPrice && productDetails?.totalPrice?.value !== undefined">
                                            <span>{{productDetails?.totalPrice?.value | currency}}</span>
                                            <br />
                                            <span class="priceTaxBlock 1"
                                            *ngIf="productDetails?.sim_excise_tax.value >= 0.00">
                                            {{productDetails?.sim_excise_tax.value | currency}}
                                            {{productDetails?.sim_excise_tax?.currencyIso}}/
                                            {{productDetails?.product?.unit}} federal excise tax will be added.
                                        </span>
                                        </span>
                                    </section>
                                </section>
                            </section>
                            <!--Added new section as on confirmation page, federal excise tax to be shown too without units selector and update button-->
                            <section class="row unit-calc" *ngIf="unitSection==='NoUnitsCheckout'">
                                <section class="col-md-4 col-xs-6 bottom-spacing price-area"
                                    *ngIf=" !productDetails?.product?.flu">
                                    <b>Unit Price</b>
                                    <section class="number">
                                        <span
                                            *ngIf="productDetails?.totalPrice == undefined || productDetails?.totalPrice?.value === undefined">-</span>
                                        <span
                                            *ngIf="productDetails?.totalPrice && productDetails?.totalPrice?.value !== undefined">
                                            <span>{{productDetails?.totalPrice?.value | currency}}</span>
                                            <br />
                                            <span class="priceTaxBlock"
                                            *ngIf="productDetails?.sim_excise_tax.value >= 0.00">
                                            {{productDetails?.sim_excise_tax.value | currency}}
                                            {{productDetails?.sim_excise_tax?.currencyIso}}/
                                            {{productDetails?.product?.unit}} federal excise tax will be added.
                                        </span>
                                        </span>
                                    </section>
                                </section>
                            </section>
                            <section class="row unit-calc" *ngIf="unitSection==='Update' || unitSection==='AddToCart'">
                                <section class="col-md-4 col-xs-6 bottom-spacing price-area"
                                    *ngIf=" !productDetails?.product?.flu">
                                    <b>{{'plp.yourPrice'|cxTranslate}}</b>
                                    <section class="number">
                                        <span
                                            *ngIf="productDetails?.totalPrice == undefined || productDetails?.totalPrice?.value === undefined">-</span>
                                        <span 
                                        *ngIf="productDetails?.totalPrice && productDetails?.totalPrice?.value !== undefined && productDetails?.totalPrice?.value <= 0 && productDetails?.product?.hidePriceForProduct">$--</span>
                                            <span
                                            *ngIf="productDetails?.totalPrice && productDetails?.totalPrice?.value !== undefined && productDetails?.totalPrice?.value > 0 && !productDetails?.product?.hidePriceForProduct">
                                            <span>
                                                {{productDetails?.totalPrice?.value | currency}}
                                            </span>
                                            {{productDetails?.totalPrice?.currencyIso}}
                                            <br />
                                            <span class="priceTaxBlock"
                                                *ngIf="productDetails?.sim_excise_tax.value > 0.00  && !productDetails?.product?.hidePriceForProduct; else prodFedralTax">
                                                {{productDetails?.sim_excise_tax.value | currency}}
                                                {{productDetails?.sim_excise_tax?.currencyIso}}/
                                                {{productDetails?.product?.unit}} federal excise tax will be added.
                                            </span>
                                             <ng-template #prodFedralTax>
                                                <span class="priceTaxBlock"  *ngIf="!productDetails?.product?.hidePriceForProduct">
                                                {{productDetails?.product?.fexciseTax?.value | currency}}
                                                {{productDetails?.product?.fexciseTax?.currencyIso}}/
                                                {{productDetails?.product?.unit}}
                                                federal excise tax
                                                will be added.
                                             </span>
                                             </ng-template>
                                        </span>
                                    </section>
                                </section>
                                <section class="col-md-4 col-xs-6 bottom-spacing units-area">
                                    <section *ngIf="!productDetails?.product?.discontinued">
                                        <section *ngIf="productDetails?.product?.available">
                                            <b class="prodUnits">{{'plp.units'|cxTranslate}}</b>

                                            <section class="unit-area">

                                                <img src="../../assets/icons/{{baseSiteId}}/less_new.svg"
                                                    id="{{'unitMinus'+productDetails?.product?.code+'-modal'}}"
                                                    (click)="performQuantityComputation(2,productDetails?.product?.code,productDetails?.product?.quantityPerUnit,
                                                        productDetails?.product?.uom,productDetails?.product?.allocationInfos?.availableQty);
                                                        showRestrictionPopoverFor !== productDetails?.product.code && p1.close()" alt="">

                                                <ng-template #popContent>
                                                    <img [src]="'../../../../assets/icons/'+baseSiteId+'/warning_red_new.png'"
                                                        alt="warning_icon" />
                                                    <span>Quantity limit is '{{
                                                        productDetails?.product.allocationInfos?.availableQty }}'
                                                        Units</span>
                                                </ng-template>

                                                <input type="number" class="prod-quantity text-center" #number
                                                    id="{{'prodQuantity'+productDetails?.product?.code+'-modal'}}"
                                                    [value]="productDetails?.product?.allocationInfos?.availableQty === '0' ? 0 : productDetails?.quantity"
                                                    onkeypress="return /[0-9a-zA-Z]/i.test(event.key)"
                                                    [ngbPopover]="popContent" placement="top" triggers="manual"
                                                    #p1="ngbPopover" [autoClose]="false"
                                                    popoverClass="custom-restriction-popover"
                                                    (keyup)="
                                                        performQuantityComputation(null,productDetails?.product?.code,productDetails?.product?.quantityPerUnit,
                                                        productDetails?.product?.uom,productDetails?.product?.allocationInfos?.availableQty);
                                                        showRestrictionPopoverFor == (productDetails?.product?.code) ? p1.open() : p1.close()"
                                                    appNoMouseScroll />


                                                <img [src]="'../../assets/icons/'+baseSiteId+'/more.svg'"
                                                    id="{{'unitPlus'+productDetails?.product?.code+'-modal'}}"
                                                    (click)="performQuantityComputation(1,productDetails?.product?.code,productDetails?.product?.quantityPerUnit,
                                                        productDetails?.product?.uom,productDetails?.product.allocationInfos?.availableQty); showRestrictionPopoverFor == productDetails?.product.code && p1.open()"
                                                    alt="">


                                            </section>
                                            <section class="doses-section"
                                                id="{{'noOfDoses'+productDetails?.product?.code+'-modal'}}">
                                                {{productDetails?.product?.quantityPerUnit ?
                                                productDetails?.product?.quantityPerUnit *
                                                productDetails?.quantity : 1 * productDetails?.quantity}}
                                                {{productDetails?.product?.uom}}
                                            </section>
                                        </section>
                                    </section>
                                </section>

                                <section
                                    class="col-md-4 col-sm-4 col-xs-12 bottom-spacing button-area align-self-center">
                                    <button *ngIf="unitSection==='Update';else addToCart"
                                        class="btn-primary login-btn updateCartBtn ml-5"
                                        data-di-id="di-id-2fea5a72-b2e23002" [ngbPopover]=popTitleSuccess
                                        placement="bottom" triggers="manual" #p2="ngbPopover" placement="bottom"
                                        popoverClass="updatecart-msg"
                                        (click)="updateCart(productDetails?.product?.code+'-modal',p2)"
                                        [disabled]="buttonDisable || showRestrictionPopoverFor == productDetails?.product?.code">
                                        {{'addToCartItems.updateCart'|cxTranslate}}</button>

                                    <section class="added-success-container">
                                        <ng-template #popTitleSuccess>
                                            <div class="cart-value-added">
                                                <img [src]="'../../../assets/icons/'+baseSiteId+'/confirmation-positive-green.png'"
                                                    class="positive-green-icon" alt="success">
                                                <span class="confirmation-itemsadded">{{itemAddedQuantity}}
                                                    {{'addToCartItems.addUpdateSuccess'|cxTranslate}}</span>
                                            </div>
                                        </ng-template>
                                        <ng-template #popTitleAddSuccess>
                                            <div class="cart-value-added">
                                                <img [src]="'../../../assets/icons/'+baseSiteId+'/confirmation-positive-green.png'"
                                                    class="positive-green-icon" alt="success">
                                                <span class="confirmation-itemsadded">{{itemAddedQuantity}}
                                                    {{'addToCartItems.addEntrySuccess'|cxTranslate}}</span>
                                            </div>
                                        </ng-template>
                                    </section>


                                    <ng-template #addToCart>
                                        <button class="btn-primary login-btn updateCartBtn two"
                                            data-di-id="di-id-2fea5a72-b2e23002" [ngbPopover]=popTitleAddSuccess
                                            placement="bottom" triggers="manual" #p3="ngbPopover" placement="bottom"
                                            popoverClass="addtocart-msg"
                                            (click)="addToSessionCart(productDetails?.product?.code+'modal',productDetails?.product?.code,productDetails?.totalPrice?.value, p3)"
                                            [disabled]="!productDetails?.product?.available">
                                            {{'addToCartItems.addCart'|cxTranslate}}</button>
                                    </ng-template>
                                </section>
                                <section class="bottom-spacing availability-text"
                                    *ngIf="!productDetails?.product?.discontinued && !productDetails?.product?.sapAllocation && !productDetails?.product?.flu">
                                </section>
                            </section>
                            <section
                                *ngIf="!productDetails?.product?.discontinued && productDetails?.product?.available"
                                class="products-accordion clear-fix pt2">
                                <section class="panel-group">
                                    <section class="panel panel-default" *ngIf="volumePrices?.length > 0">
                                        <section class="panel-heading panel-endborder">
                                            <section class="first-level-acc">
                                                <label><img src="'../../assets/icons/'+baseSiteId+'/price-master.png'"
                                                        class="accordion-img" alt="">
                                                    {{'plp.volumePricing'|cxTranslate}}</label>
                                                <span data-toggle="collapse" data-parent="#accordion" href="#pdp-list1"
                                                    class="acc-plus-icon fa" aria-expanded="panelVolumeExpanded"
                                                    (click)="panelVolumeExpanded = !panelVolumeExpanded"
                                                    [ngClass]="panelVolumeExpanded?'fa-minus':'fa-plus collapsed'"></span>
                                            </section>
                                        </section>
                                        <section id="pdp-list1" class="panel-collapse collapse"
                                            aria-expanded="panelVolumeExpanded"
                                            (click)="panelVolumeExpanded = !panelVolumeExpanded"
                                            [ngClass]="panelVolumeExpanded?'in':''">
                                            <section class="panel-body">
                                                <section class="discount-list" id="vol-price-pdp">
                                                    <table aria-describedby="pdpTable">
                                                        <thead>
                                                            <th id=""></th>
                                                        </thead>
                                                        <tbody *ngFor="let prices of volumePrices; let i=index">
                                                            <tr>
                                                                <td>{{prices?.minQuantity}} - {{prices?.maxQuantity}}
                                                                    {{'plp.units'|cxTranslate}}:
                                                                </td>
                                                                <td>{{prices?.value | currency}}</td>
                                                                <td><span *ngIf="i>0"
                                                                        class="save-price">{{'plp.save'|cxTranslate}}
                                                                        {{volumePrices[0].value
                                                                        -
                                                                        volumePrices[i].value |
                                                                        currency}}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </section>
                                            </section>
                                        </section>
                                    </section>
                                </section>

                            </section>
                        </section>

                        <!-- The End -->
                        <!-- restrictions start here  -->
                        <ng-container *ngIf="productDetails?.product as entry">
                            <ng-container *ngIf="!entry.unavailable; else notAvailable">
                                <p class="err-text" *ngIf="!entry.orderable">
                                    This product is no longer orderable
                                </p>
                                <p class="err-text" *ngIf="!entry.available">
                                    This product is temporarily out of stock
                                </p>
                                <p class="err-text" *ngIf="entry?.discontinued && entry?.discontinuedText != null && entry?.discontinuedText != ''; else elseBlockMsg">
                                    <span [innerHTML]="entry?.discontinuedText"></span>
                                </p>
                                <ng-template #elseBlockMsg>
                                    <p class="err-text" *ngIf="entry?.discontinued">
                                    This product has been discontinued
                                    </p>
                                 </ng-template>

                                <div class="reserve-info" *ngIf="
                            entry?.variantOptions[0]?.flu && 
                            entry.variantOptions[0].shipNow?.toLowerCase() === 'off' &&
                            !entry.discontinued &&
                            entry.available &&
                            entry.orderable">
                                    <p *ngIf="baseSiteId == 'vsh'">
                                        For assistance with your reservation, call 1-800-VACCINE
                                        (1-800-822-2463) or contact your Sanofi Pasteur vaccine
                                        specialist.
                                    </p>
                                    <p *ngIf="baseSiteId == 'vax'">
                                        For assistance with your reservation, call 1-800-752-9338 or
                                        contact your Sanofi Pasteur vaccine
                                        specialist.
                                    </p>
                                </div>

                                <!-- <div class="allocation-info" *ngIf="
                               !entry.discontinued &&
                               entry.available &&
                               entry.orderable &&
                               entry.allocationInfos 
                              ">
                                    <p>This product has quantity limits</p>
                                    <p (click)="openLimitationModal(entry)">View Details</p>
                                </div> -->
                            </ng-container>
                            <ng-template #notAvailable>
                                <p class="err-text">This product is currently unavailable</p>
                            </ng-template>
                        </ng-container>

                        <!-- restrictions ends here  -->
                        <section>
                            <section class=" products-accordion clear-fix pt2 ">
                                <section class="panel-group ">
                                    <p class="allcll collapsed" (click)="toggleAll()">
                                        <a>+/- All</a>
                                    </p>
                                    <!-- update2 -->
                                    <section class="panel panel-default "
                                        *ngIf="productDetails?.product?.storageDescription">
                                        <section class="panel-heading ">
                                            <section class="first-level-acc ">
                                                <label><img [src]="'../../assets/icons/'+baseSiteId+'/storage.png'"
                                                        class="accordion-img " alt=" "> Storage & Handling
                                                </label> <span data-toggle="collapse " data-parent="#accordion "
                                                    href="#pdp-list3 " class="acc-plus-icon fa "
                                                    aria-expanded="panelProductExpanded "
                                                    (click)="panelProductExpanded=! panelProductExpanded "
                                                    [ngClass]="panelProductExpanded? 'fa-minus': 'fa-plus collapsed' "></span>
                                            </section>
                                        </section>
                                        <section id="pdp-list3 " class="panel-collapse collapse "
                                            aria-expanded="panelProductExpanded "
                                            (click)="panelProductExpanded=! panelProductExpanded "
                                            [ngClass]="panelProductExpanded? 'in': '' ">
                                            <section class="panel-body productupdate-p " 
                                            [innerHTML]="productDetails?.product?.storageDescription">
                                            </section>
                                       </section>
                                    </section>
                                    <!--  -->
                                    <section class="panel panel-default " *ngIf="productDetails.product.calculator">
                                        <section class="panel-heading ">
                                            <section class="first-level-acc ">
                                                <label><img
                                                        [src]="'../../assets/icons/'+baseSiteId+'/calculator-plum.svg'"
                                                        class="accordion-img " alt=" ">
                                                    {{'plp.calcinfo'|cxTranslate}}
                                                </label> <span data-toggle="collapse " data-parent="#accordion"
                                                    href="#pdp-list5" class="acc-plus-icon fa "
                                                    aria-expanded="panelProductExpanded2 "
                                                    (click)="panelProductExpanded2=! panelProductExpanded2 "
                                                    [ngClass]="panelProductExpanded2? 'fa-minus': 'fa-plus collapsed' "></span>
                                            </section>
                                        </section>
                                        <section id="pdp-list5" class="panel-collapse collapse "
                                            aria-expanded="panelProductExpanded2 "
                                            [ngClass]="panelProductExpanded2? 'in': '' ">
                                            <section class="panel-body productupdate-p ">
                                                {{'plp.calculatorLabel'|cxTranslate}}</section>
                                            <section class="panel-body productupdate-p ">
                                                <div class="row">
                                                    <div class="col-md-3"><input #userinput type="text"
                                                            [(ngModel)]="searchValue" required class="calcInput"
                                                            name="volumeinLbs">&nbsp;</div>
                                                    <div class="col-md-2 calcBtn"><button type="submit"
                                                            class="btn btn-primary oi-blue-button reviewvalidbtn"
                                                            data-di-id="di-id-7a6cb2cd-cb37948a"
                                                            (click)="calculateUnit(userinput)">
                                                            {{ "plp.calcBtn" | cxTranslate }}
                                                        </button></div>
                                                    <div class="col-md-6">
                                                        <div id="validdiv"
                                                            class="col-xs-6 col-md-6 col-sm-6 calc-result"
                                                            *ngIf="isClicked && isValidInput">
                                                            <div class="prod-calcresult">{{calculatedValue}} mLs</div>
                                                        </div>
                                                        <div id="invaliddiv"
                                                            class="col-xs-6 col-md-6 col-sm-6 calc-result"
                                                            *ngIf="isClicked && !isValidInput">
                                                            <div class="prod-invalidvalue">{{'plp.invalidMessage' |
                                                                cxTranslate
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                            <section class="panel-body productupdate-p ">
                                                {{'plp.needAssistance'|cxTranslate}}
                                            </section>
                                        </section>
                                    </section>
                                    <!--  -->
                                    <section class="panel panel-default"
                                        *ngIf="productDetails?.product?.innerText && productDetails?.product?.innerText !== ''">
                                        <section class="panel-heading">
                                            <section class="first-level-acc">
                                                <label><img
                                                        [src]="'../../assets/icons/'+baseSiteId+'/warning_red_new.png'"
                                                        class="accordion-img" alt=" " />
                                                    Important notices
                                                </label>
                                                <span data-toggle="collapse " data-parent="#accordion "
                                                    href="#pdp-list2" class="acc-plus-icon fa"
                                                    aria-expanded="panelProductExpanded3"
                                                    (click)="panelProductExpanded3 = !panelProductExpanded3" [ngClass]="
                                            panelProductExpanded3 ? 'fa-minus' : 'fa-plus collapsed'
                                          "></span>
                                            </section>
                                        </section>
                                        <section id="pdp-list2" class="panel-collapse collapse"
                                            aria-expanded="panelProductExpanded3"
                                            (click)="panelProductExpanded3 = !panelProductExpanded3"
                                            [ngClass]="panelProductExpanded3 ? 'in' : ''">
                                            <section class="panel-body productupdate-p">
                                                <p class="inner-text">
                                                    <span [innerHtml]="productDetails?.product?.innerText"></span>
                                                </p>
                                            </section>
                                        </section>
                                    </section>
                                    <!--  -->
                                </section>
                            </section>
                        </section>
                    </section>
                </section>
                <aside aria-label="Product Details Pdf "
                    class="col-sm-3 right-navigation float-left resources-section ">
                    <section *ngIf="productDetails?.product?.documents?.length > 0">
                        <section class=" prod-detail-pdfs ">
                            <p class=" pdfs-title ">
                                Document</p>
                            <p class="pdfs-list" *ngFor="let item of productDetails?.product?.documents; let i = index">
                                <img class=" pdf-icon " [src]="' ../../assets/icons/'+baseSiteId+'/pdf.png'" alt=" ">
                                <a alt=" " [href]="baseUrl + item.url" target=" _blank " class=" file-link blue ">
                                    {{item.name}}</a>
                                <!-- {{item.realFileName}}</a> -->
                            </p>
                        </section>
                    </section>
                </aside>
            </section>

        </section>
    </div>
</div>